import { resourceWithPagination } from './utils';

const RESOURCE_NAME = 'emails';

export default function emailsRoutes(context) {
  resourceWithPagination(context, {
    resource: RESOURCE_NAME,
    paginatedSerializer: 'paginated-emails',
    except: ['create', 'update'],
  });
}
